import {
    COMPETITIONS_FAILURE,
    COMPETITIONS_REQUEST,
    COMPETITIONS_SUCCESS,
    COMPETITIONS_PATCH_SUCCESS,
    COMPETITIONS_POST_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const competitionListReducer = (state = initialState, action) => {
    const {type, data, competition} = action;

    switch (type) {
        case COMPETITIONS_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case COMPETITIONS_PATCH_SUCCESS: {
            return {
                ...state,
                data: state.data.map(d => d.id === competition.id ? competition : d)
            }
        }

        case COMPETITIONS_POST_SUCCESS: {return {
            ...state,
            data: [...state.data, competition]
        }}

        case COMPETITIONS_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case COMPETITIONS_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
